import {Component, Prop, Vue} from "vue-property-decorator";
import flatPickr from "vue-flatpickr-component";
import {BallPulseLoader} from "vue-loaders";
import VueSimpleSpinner from "vue-simple-spinner";
import {HTTP} from "@/utils/httpCommonUtil";
import GenericModal from '@/componentsReusable/genericModal.vue';
import DataLoadCard from "@/componentsReusable/DataLoadCard.vue";
import ExpandableRowItems from "@/componentsReusable/ExpandableRowItems.vue";
import FacilityControl from "@/componentsReusable/FacilityControl.vue";
import {Writeable} from "@/interfaces/Writeable";

@Component(
  {
    components: {
      flatPickr,
      BallPulseLoader,
      VueSimpleSpinner,
      GenericModal,
      DataLoadCard,
      ExpandableRowItems,
      FacilityControl
    },
  }
)
export default class FacilityCredentialingDocumentFill extends Vue {

  @Prop({type: [String, Number], required: true})
  providerId!: string|number;

  loadingCounter = 0;
  filledFacilityDocuments: any = [];

  async getFilledDocuments () {
    this.loadingCounter++;
    try {
      const response = await HTTP.get(`/api/providers/${this.providerId}/facility-credential-fill`);
      if (!response.data || !response.data.data) {
        throw new Error("Error retrieving filled facility credential documents.");
      }
      let freshFacilityDocuments = response.data.data;
      freshFacilityDocuments.forEach( (facilityDocument: any) => {
        facilityDocument.isNew = false;
        facilityDocument.isUpdating = false;
        facilityDocument.expanded = false;
      });
      this.filledFacilityDocuments = freshFacilityDocuments;
    } catch (err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred retrieving filled facility documents.'
      });
    } finally {
      this.loadingCounter--;
    }
  }

  async openAttachment (s3Key: string) {
    const url = '/api/s3/signed-url/get';
    try {
      const response = await HTTP.get(url + `?s3key=${s3Key}`);
      if (!response.data || !response.data.data) {
        throw new Error("Error getting attachment.");
      }
      window.open(response.data.data, '_blank');
    } catch(err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred saving uploaded document.'
      });
    }
  }

  facilitySelected(facility: any, facilityFilledDocument: any) {

    facilityFilledDocument.facilityId = facility.id;
    facilityFilledDocument.facilityName = facility.name;
  }

  addNew() {
    this.filledFacilityDocuments.push({
      facilityId: 0,
      facilityName: '',
      isNew: true,
      isUpdating: false,
      expanded: true
    })
  }

  canAdd() {
    return this.filledFacilityDocuments.every((item: Writeable) => {
      return !item.isNew;
    });
  }

  async generateDocument(filledFacilityDocument: any) {
    try {
      filledFacilityDocument.isUpdating = true;
      const response = await HTTP.post(`/api/providers/${this.providerId}/facility-credential-fill`, filledFacilityDocument);
      if (!response.data || !response.data.data) {
        throw new Error("Error generating filled document.");
      }
      await this.getFilledDocuments();
    } catch(err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred saving uploaded document.'
      });
      filledFacilityDocument.isUpdating = false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/provider/cards/facilitycredentialingdocuments/FacilityCredentialingDocumentFill.ts